var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"pastWinnersModal","hide-footer":"","hide-header":"","body-class":"p-0"}},[_c('div',{staticClass:"modal-card card",staticStyle:{"border":"none"}},[_c('WinnerBoardHeader'),_c('WinnerBoardPastWinners',{attrs:{"show-immediately":"true"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }